import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_ALL_CONTACTUSS,
  EDIT_CONTACTUS,
  DELETE_CONTACTUS,
  GET_CONTACTUS,
  ADD_CONTACTUS,
} from "./actionTypes";

import {
  getAllContactUssApi,
  editContactUsApi,
  deleteContactUsApi,
  getContactUsApi,
  addContactUsApi,
} from "api/contactUs";

import {
  getAllContactUssSuccess,
  getAllContactUssFailure,
  editContactUsSuccess,
  editContactUsFailure,
  deleteContactUsSuccess,
  deleteContactUsFailure,
  getContactUsSuccess,
  getContactUsFailure,
  addContactUsSuccess,
  addContactUsFailure,
} from "./actions";
import { toastErrorMessageNew } from "helpers/toaster/toastErrorMessageNew";

// api calls
function* getAllContactUss() {
  try {
    const { data } = yield call(getAllContactUssApi);

    yield put(getAllContactUssSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(getAllContactUssFailure(error.response?.data?.message || error));
  }
}

function* editContactUs({ payload }) {
  try {
    const { data } = yield call(editContactUsApi, payload);

    yield put(editContactUsSuccess(data));
    payload.navigate("/socialTypes");
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(editContactUsFailure(error.response?.data?.message || error));
  }
}

function* getContactUs({ payload }) {
  try {
    const { data } = yield call(getContactUsApi, payload);

    yield put(getContactUsSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(getContactUsFailure(error.response?.data?.message || error));
  }
}

function* deleteContactUs({ payload }) {
  try {
    yield call(deleteContactUsApi, payload);
    yield put(deleteContactUsSuccess(payload));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(deleteContactUsFailure(error));
  }
}

function* addContactUs({ payload }) {
  try {
    const { data } = yield call(addContactUsApi, payload.data);

    yield put(addContactUsSuccess(data));

    payload.navigate("/socialTypes");
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(addContactUsFailure(error.response?.data?.message || error));
  }
}

// watchers
export function* watchgetAllContactUss() {
  yield takeEvery(GET_ALL_CONTACTUSS, getAllContactUss);
}

export function* watcheditContactUs() {
  yield takeEvery(EDIT_CONTACTUS, editContactUs);
}
export function* watchGetContactUs() {
  yield takeEvery(GET_CONTACTUS, getContactUs);
}

export function* watchDeleteContactUs() {
  yield takeEvery(DELETE_CONTACTUS, deleteContactUs);
}

export function* watchAddContactUs() {
  yield takeEvery(ADD_CONTACTUS, addContactUs);
}

function* socialTypesSaga() {
  yield all([
    fork(watchgetAllContactUss),
    fork(watcheditContactUs),
    fork(watchDeleteContactUs),
    fork(watchGetContactUs),
    fork(watchAddContactUs),
  ]);
}

export default socialTypesSaga;
